import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'

import DateTimeRangePicker from '@/components/core/DateTimeRangePicker.vue'
import { useDateTimePeriodFormat } from '@/composables/date'
import { DateRange } from '@/types/transportation'

export interface TransportationDateTimeRangePickerProps {
  value?: DateRange
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationDateTimeRangePicker',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: DateRange | undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: DateRange
};





const showPicker = ref(false)

const internalValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  },
})

const dateString = useDateTimePeriodFormat(internalValue)

return { __sfc: true,props, emit, showPicker, internalValue, dateString, DateTimeRangePicker }
}

})